import avatar01 from '../assets/boy_avatar1.png';
import avatar02 from '../assets/boy_avatar2.png';
import avatar03 from '../assets/boy_avatar3.png';
import avatar04 from '../assets/boy_avatar4.png';
import avatar05 from '../assets/girl_avatar1.png';
import avatar06 from '../assets/girl_avatar2.png';
import avatar07 from '../assets/girl_avatar3.png';
import avatar08 from '../assets/girl_avatar4.png';

export const DEFAULT_PROFILE_AVATAR = 'avatar-01';

export const PROFILE_AVATARS = {
  'avatar-01': avatar01,
  'avatar-02': avatar02,
  'avatar-03': avatar03,
  'avatar-04': avatar04,
  'avatar-05': avatar05,
  'avatar-06': avatar06,
  'avatar-07': avatar07,
  'avatar-08': avatar08,
};

export const PROFILE_AVATAR_KEYS = Object.keys(PROFILE_AVATARS);